import { isEqual } from 'lodash';

import apisauseCreator from '../../helpers/apisause';
import { InsighttNotification } from '../../helpers/insightt-notification';
import { TOKEN_EXPIRED } from '../../constants/app.constants';
import { ENVIRONMENT } from '../../constants/env-constants';
import { cloudLogger } from './insightt-logger';
import { getBearerAccessToken } from '../../helpers/auth-header';
import { validateTokenExpiration } from '@rapid-recovery-agency-inc/insightt-shared';
import { logoutSignOutAndCleanup } from '../../shared/utils';

let controller = new AbortController();

const PUBLIC_AUTH_URL_PARTS = [
  'logout',
  'login',
  'set-password',
  'reset-password',
  'accept-invitation',
  'forgot-password',
];

const isPublicAuthRequest = (url = '') => PUBLIC_AUTH_URL_PARTS.some((part) => url.includes(part));

// Push device registration runs in the background, so its 401 is not treated as a lost session;
// the next session request reports that on its own.
const isBackgroundRequest = (url = '') => url.includes('auth/device-token');

const naviMonitor = (response) => {
  // T029: mode-neutral (FR-006/FR-008) — resolves the current Bearer token through the boundary
  // (SSO or legacy) instead of reading the legacy `access_token` cookie directly, so this
  // client-side expiry check/forced-logout applies regardless of which mode is active.
  const tokenAuth = getBearerAccessToken();
  const requestUrl = response.config?.url || '';
  const isPublicAuthUrl = isPublicAuthRequest(requestUrl);

  if (tokenAuth && !isPublicAuthUrl) {
    const expiredToken = validateTokenExpiration(tokenAuth);
    if (expiredToken === true) {
      controller.abort();
      controller = new AbortController();
      logoutSignOutAndCleanup();
    }
  }

  if (!response.ok) {
    cloudLogger(response);
  }
  // One unauthorized episode, one owner (T066): `logoutSignOutAndCleanup()` joins the page's single
  // sign-out, so several 401s (or a 401 plus an expired token) still clear once and navigate once.
  // A 401 from a public auth endpoint (login, logout, password and invitation flows) is not a lost
  // session; a 401 from logout means the legacy session had already ended, which the sign-out owner
  // already treats as terminated.
  if (isEqual(response.status, 401) && !isPublicAuthUrl && !isBackgroundRequest(requestUrl)) {
    if (isEqual(response.data?.message, 'jwt expired')) {
      InsighttNotification('error', TOKEN_EXPIRED, null);
    }
    logoutSignOutAndCleanup();
  }
};

const insighttAPI = apisauseCreator(
  // BaseURL
  ENVIRONMENT.BACKEND_SERVER,
  // Headers
  {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    signal: controller.signal,
  },

  // 50 second timeout...
  500000,
);

insighttAPI.addMonitor(naviMonitor);

export default insighttAPI;
